define('drops/radioButton/radioButton',[
    'jquery',
    'lq/drop',
    'lq/style'
], function ($, Drop, Style) {
    'use strict';

    var defaults = {
        data: {
            useBuiltInStyle: true
        }
    };

    function RadioButton(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.renderRadioButton();


        this.$element
	        .addClass('boxToBorderSize')
	        .css({
	            whiteSpace: 'pre-wrap'
	        });

        Style.renderStyles(this);
    };

    Drop.extend(RadioButton, Drop);

    RadioButton.typeName = 'RadioButton';

    RadioButton.prototype.renderRadioButton = function () {
        var self = this;
        this.$input = $('<input type = "radio" />')
            .attr('value', this.data.value)
            .attr('tabindex', this.data.tabIndex)
            .on('change', function () {
                self.updateParent();

                if ($(this).is(':checked'))
                    self.triggerSelectedEvent();
            });

        if (this.data.useBuiltInStyle) {
            this.$input
                .appendTo(this.$element);
        } else {
            this.$wrapper = $('<label class="customCheckState" />')
                .append(this.$input)
                .append($('<div class="customCheckState-tick"></div>'))
                .appendTo(this.$element);
        }

        this.$label = $('<span />')
            .text(this.data.text)
            .appendTo(this.$element);
    };

    RadioButton.prototype.preRender = function () {
        this.piping.visibility.apply(this);

        this.applyPosition();

        // note: append defaultEventArg to the name when used in for instance a list,
        // making the radio button group unique for each list-item
        var defaultEventArg = this.getDefaultEventArg();
        this.$input.attr('name', defaultEventArg ? this.parent.data.id + '_' + defaultEventArg : this.parent.data.id);
        
        if (this.parent.value === this.data.value)
            this.$input.prop('checked', true);

        if (this.parent.data.readOnly) {
            this.$input.prop('disabled', true);
        } else {
            var self = this;
            this.$label
                .on('click', function () {
                    self.select();
                    self.updateParent();
                });
        }
    };

    RadioButton.prototype.triggerSelectedEvent = function () {
        // note: don't send the value as the parameter for the event 
        // currently these events are used in lists and current implementations
        // assume the parameter will contain the id of the row
        if (this.data.eventing && this.data.eventing.selected && this.data.eventing.selected.enabled === true)
            this.triggerEvent(this.data.eventing.selected.raisedEventName);
    };

    RadioButton.prototype.updateParent = function () {
        var value = this.data.value;
        this.parent.radioButtonSelectionChanged(value);
    };

    RadioButton.prototype.select = function () {
        if (this.$input.is(':checked'))
            return;

        this.$input.prop('checked', true);
        this.triggerSelectedEvent();
    };

    RadioButton.prototype.unselect = function () {
        this.$input.prop('checked', false);
    };
    
    return RadioButton;
});
